import { createSlice } from '@reduxjs/toolkit';

const initialVoidState = {
	listLoading: false,
	actionsLoading: false,
	totalCount: 0,
	entities: null,
	voidForEdit: undefined,
	lastError: null,
};

export const callTypes = {
	list: 'list',
	action: 'action',
};

export const voidSlice = createSlice({
	name: 'void',
	initialState: initialVoidState,
	reducers: {
		catchError: (state, action) => {
			state.error = action.payload.error;
			if (action.payload.callType === callTypes.list) {
				state.listLoading = false;
			} else {
				state.actionsLoading = false;
			}
		},

		startCall: (state, action) => {
			state.error = null;
			if (action.payload.callType === callTypes.list) {
				state.listLoading = true;
			} else {
				state.actionsLoading = true;
			}
		},

		// findVoids
		voidsFetched: (state, action) => {
			const { total_items, items } = action.payload;
			state.listLoading = false;
			state.error = null;
			state.entities = items;
			state.totalCount = total_items;
		},

		// Set to default state actionLoading & error
		voidReload: (state, action) => {
			state.actionsLoading = false;
			state.listLoading = false;
			state.error = null;
		},

	},
});

